export const getStatusColor = (status) =>
  status === "active"
    ? "bg-green-100 text-green-800 dark:bg-green-500/20 dark:text-green-200"
    : "bg-red-100 text-red-800 dark:bg-red-500/20 dark:text-red-200";